import { useToastMessage } from "@backpac/monica";
import { type ReactNode, useEffect } from "react";
import { ErrorBoundary, type FallbackProps } from "react-error-boundary";

export interface ErrorBoundaryWithToastProps {
  children: ReactNode;
  errorMessage?: string;
}

export function ErrorBoundaryWithToast({ children, errorMessage }: ErrorBoundaryWithToastProps) {
  return (
    <ErrorBoundary
      FallbackComponent={(props) => (
        <ShowToast {...props} errorMessage={errorMessage}>
          {children}
        </ShowToast>
      )}
    >
      {children}
    </ErrorBoundary>
  );
}

function ShowToast({ error, errorMessage, children }: FallbackProps & { errorMessage?: string; children: ReactNode }) {
  const { error: showErrorToast } = useToastMessage();

  useEffect(() => {
    showErrorToast(errorMessage || error.message || "An unexpected error occurred");
  }, [error, errorMessage, showErrorToast]);

  return <>{children}</>;
}
